.browse {
  max-width: 100%;
}